import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { LocalizationService } from './localization.service';
import { ProfilApi, User } from '../apis/profil.api';
import { OAuthService } from 'angular-oauth2-oidc';
import { Company, CompanyApi, CompanyList } from '../apis/company.api';

@Injectable({
  providedIn: 'root',
})
export class UserContextService {
  private currentUserData = new BehaviorSubject<User | null>(null);
  private currentUserCompaniesData = new BehaviorSubject<CompanyList | null>(
    null,
  );

  public static staticCurrentUser: User | null = null;

  public currentUser = this.currentUserData.asObservable();
  public currentUserCompanies = this.currentUserCompaniesData.asObservable();

  profilApi = inject(ProfilApi);
  companyApi = inject(CompanyApi);
  oauthService = inject(OAuthService);

  constructor() {}

  public getCurrentUser() {
    return this.currentUserData.getValue();
  }

  public updateData(data: User | null) {
    UserContextService.staticCurrentUser = data;
    this.currentUserData.next(data);
  }

  public updateCompaniesData(data: CompanyList) {
    this.currentUserCompaniesData.next(data);
  }

  public getCompaniesData(): Company[] {
    return this.currentUserCompaniesData.getValue() !== null
      ? this.currentUserCompaniesData.getValue()!.data
      : [];
  }

  public async reloadCurrentUserIfNull(): Promise<User | null> {
    try {
      let user = this.currentUserData.getValue();

      if (user == null) {
        user = await this.reloadCurrentUser();

        return user;
      }

      return user;
    } catch (e) {
      return null;
    }
  }

  private checkLang(userTmp: any): void {
    try {
      if (userTmp.lang !== LocalizationService.DEFAULT_LOCALE) {
        this.profilApi
          .patchMe({ lang: LocalizationService.DEFAULT_LOCALE } as any)
          .finally(() => {});
      }
    } catch (e) {
      console.log(e);
    }
  }

  public async reloadMyCompanies() {
    const companies = await this.companyApi.getCompanies().finally(() => {});
    this.updateCompaniesData(companies);
  }

  public async reloadCurrentUser(): Promise<User> {
    try {
      if (await this.oauthService.refreshToken()) {
        const userTmp = await this.profilApi.me();

        if (
          !(
            userTmp.roles!.indexOf('ROLE_ADMIN') >= 0 ||
            userTmp.roles!.indexOf('ROLE_SUPPORT') >= 0
          )
        ) {
          await this.reloadMyCompanies();
        }

        this.checkLang(userTmp);
        this.updateData(userTmp);
        return userTmp;
      }
    } catch (e) {
      return Promise.reject(new Error('Not connected ?'));
    }

    return Promise.reject(new Error('Not connected ?'));
  }

  public clear(): void {
    this.updateData(null);
  }
}
